// The printer renders this page inside Docker, where it reaches the API by
// service name rather than through the browser's host. Kerdora's client uses
// the same "printer" user-agent trick against the same shared printer, so this
// hostname must not be one both apps claim — hence imapper-, not im-.
const local =
  navigator.userAgent === "printer"
    ? "http://imapper-server:3000/"
    : "http://desktop.local:3000/";
const API_URL = import.meta.env.VITE_API_URL;
const PRINT_API_URL = import.meta.env.VITE_ENV === "local" ? local : API_URL;

const config = {
  API_URL,
  PRINT_API_URL,
  APP_URL: import.meta.env.VITE_APP_URL,
  ENV: import.meta.env.VITE_ENV,
  STRIPE_PUBLIC_KEY: import.meta.env.VITE_STRIPE_PUBLIC_KEY,
  STRIPE_PRICING_TABLE_ID: import.meta.env.VITE_STRIPE_PRICING_TABLE_ID,
};

export default config;
